
import { EntityMeta } from "@backstage/catalog-model";

export type SonarMetadataLinks = {
  project: string,
  id: string
};

export function useSonarMetaLinks(metadata: EntityMeta): SonarMetadataLinks {

  const { annotations } = metadata;

  const links = useBuildSonarLinks();

  if (!annotations) {
    return links;
  }

  const link = parseAnnotationValue(annotations['sonarqube.org/project-key'])
  
  return link || links;
}

function useBuildSonarLinks(): SonarMetadataLinks {
  return { project: '', id: '' }
}

function parseAnnotationValue(annotation: string): SonarMetadataLinks | undefined {

  if (!annotation) {
    return undefined;
  }

  const [project, ...rest] = annotation.split('/')
  const id = rest.join('/')

  return { project, id: `https://sonar.totvs.io/dashboard?id=${id}` };
}

